<template>
  <div
    class="login_background flex justify-center align-center flex-col items-center h-screen w-full bg-no-repeat bg-right"
    :style="backgroundStyle"
  >
    <div class="flex justify-start flex-col items-center" style="width: 500px">
      <div class="self-center mb-10">
        <logoSvg />
      </div>
      <ProgressBar></ProgressBar>
      <div
        class="w-4 h-0.5 flex-shrink-0 bg-coach-green-500 my-4 self-center"
      ></div>
      <div class="info-form-div text-center">
        <div class="main-body">
          <h2 class="text-3xl font-bold text-black mb-4">
            See Your Program Through Your Client's Eyes
          </h2>

          <p class="text-gray-600 text-lg mb-4">
            You just built your first program. Now experience exactly what your clients see when 
            they open it on their app - this is the moment most coaches say "okay, I get it."
          </p>

          <p class="text-gray-600 mb-4">
            Download the MyCoach app and log in with the same email and password you just used to sign up. Your program will be waiting for you.
          </p>

          <!-- QR Code -->
          <div class="flex justify-center mb-6">
            <div class="bg-white p-4 rounded-lg shadow-md">
              <img
                src="https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/FBYQcmJ3PqRMGRrJ3lwR/media/690e130a0269a3dfe6c6b49c.png"
                alt="Download App QR Code"
                class="w-48 h-48"
                @error="handleQrError"
              />
            </div>
          </div>

          <!-- Mobile Download Link -->
          <p class="text-gray-600 mb-6">
            Scan to download MyCoach → then log in with your Coach Catalyst email and password
          </p>
          <a
            :href="downloadLink"
            target="_blank"
            class="text-coach-green-500 hover:underline text-lg mb-4 inline-block"
          >
            On mobile? Tap here to download MyCoach
          </a>

          <!-- Continue Button -->
          <div class="mt-5">
            <input
              type="button"
              @click="continueToNext"
              value="Continue to Dashboard"
              class="btn button w-full rounded-lg"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiUrls from '../../api-url';
import { mapState } from 'vuex';
import getters from '../../stores/login-store/getters/login-getters';
import AuthenticationMixin from '../../authentication-mixin';
import ProgressBar from '../shared/progress-bar';
import logoSvg from '../../svgs/logoSvg.vue';

export default {
  components: { ProgressBar, logoSvg },
  mixins: [ApiUrls, AuthenticationMixin],
  data() {
    return {
      downloadLink: 'https://links.coachcatalyst.com/mycoach',
    };
  },
  beforeCreate: function() {
    document.body.style.backgroundColor = '#FFFFFF';
  },
  computed: {
    ...mapState(['generatedContent', 'trialAmount', 'urlParam', 'superOrg', 'userHasPhone']),
    backgroundStyle() {
      // The Webpacker-era `require` only exists after the vite require-loader
      // transform, so guard it for test environments.
      try {
        return {
          backgroundImage: `url(${require('images/login_background.png')})`,
        };
      } catch (e) {
        return {};
      }
    },
    contentTypeLabel() {
      if (!this.generatedContent) return 'program';

      switch (this.generatedContent.build_type) {
        case 'workout':
          return 'workout program';
        case 'nutrition':
          return 'nutrition plan';
        case 'challenge':
          return 'challenge';
        default:
          return 'program';
      }
    },
  },
  methods: {
    handleQrError(e) {
      // Fallback if QR image doesn't load
      e.target.style.display = 'none';
    },
    continueToNext() {
      // Check if user should go to payment or directly to dashboard
      if (this.urlParam || this.superOrg || !this.trialAmount) {
        // Skip payment - collect a phone number first unless one is already
        // on file (e.g. a resumed signup), then land on the dashboard.
        if (this.userHasPhone) {
          window.location.href = '/clients';
        } else {
          this.$store.commit('setSelectedStep', getters.SEND_YOUR_PHONE());
        }
      } else {
        // Go to payment info
        this.$store.commit('setSelectedStep', getters.SIGN_UP_PAYMENT_INFO());
      }
    },
  },
};
</script>
